const Menu = [{
        header: "Cibes Admin"
    },
    {
        title: "Dashboard",
        group: "apps",
        icon: "dashboard",
        name: "Dashboard"
    },
    {
        title: "Purchase Order",
        group: "apps",
        icon: "shopping_cart",
        name: "PurchaseOrder"
    },
    {
        title: "Reference Number",
        group: "apps",
        icon: "shopping_cart",
        name: "ReferenceNumber"
    },
    {
        title: "Job's Status",
        group: "apps",
        page_admin: true,
        name: "JobStatus",
        icon: "view_list"
    },
    {
        title: "Repair Reason",
        group: "apps",
        page_admin: true,
        name: "RepairReason",
        icon: "build"
    },
    {
        title: "Repair Item",
        group: "apps",
        page_admin: true,
        name: "RepairItem",
        icon: "build"
    },
    {
        title: "Replaced Spare Part",
        group: "apps",
        page_admin: true,
        name: "ReplacedSparePart",
        icon: "build"
    },
    {
        title: "Spare Part",
        group: "apps",
        page_admin: true,
        name: "SparePart",
        icon: "build"
    },
    {
        title: "Extra Task",
        group: "apps",
        page_admin: true,
        name: "ExtraTask",
        icon: "build"
    },
    {
        title: "Payment Method",
        group: "apps",
        page_admin: true,
        name: "PaymentMethod",
        icon: "build"
    },
    {
        title: "Model",
        group: "apps",
        page_admin: true,
        name: "Model",
        icon: "build"
    },
    {
        title: "User",
        group: "apps",
        page_admin: true,
        name: "User",
        icon: "account_box"
    },
    {
        title: "Sale Representative",
        group: "apps",
        page_admin: true,
        name: "SaleRepresentative",
        icon: "account_box"
    },
    {
        title: "Quality",
        group: "apps",
        page_admin: true,
        name: "Quality",
        icon: "view_list"
    },
    {
        title: "Quote",
        group: "apps",
        page_admin: true,
        name: "Quote",
        icon: "view_list"
    },
    {
        title: "Timekeeping",
        group: "apps",
        page_admin: true,
        name: "Timekeeping",
        icon: "view_list"
    },
    {
        title: "Storage Item",
        group: "apps",
        page_admin: true,
        name: "StorageItem",
        icon: "folder"
    },
];
// reorder menu
Menu.forEach(item => {
    if (item.items) {
        item.items.sort((x, y) => {
            let textA = x.title.toUpperCase();
            let textB = y.title.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    }
});

export default Menu;
